import { render, staticRenderFns } from "./ReadAloudSheet.vue?vue&type=template&id=40d86b0d"
import script from "./ReadAloudSheet.vue?vue&type=script&lang=js"
export * from "./ReadAloudSheet.vue?vue&type=script&lang=js"
import style0 from "./ReadAloudSheet.vue?vue&type=style&index=0&id=40d86b0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports